import { crmConstant } from "services/Crm/constant";
import * as yup from "yup";

export const PasswordSchema = (urlRequired) =>
  yup.object({
    provider: yup
      .string()
      .required("Provider Name is required")
      .min(3, "Provider Name must be at least 3 characters"),

    username: yup
      .string()
      .required("Username is required")
      .min(3, "Username must be at least 3 characters"),

    password: yup
      .string()
      .required("Password is required")
      .min(8, "Password should be more than 8 characters"),
    
    confirmPassword: yup
      .string()
      .oneOf([yup.ref("password"), null], "Password and Confirm Password do not match")
      .required("Confirm Password is required"),

    type: yup.string().required("Password Type is required"),
    url: yup.lazy(() =>
      urlRequired
        ? yup
            .string()
            .trim()
            .required("URL is required")
            .url("Please provide a valid URL")
        : yup.string().trim().nullable()
    ),

    notes: yup
      .string()
      .trim()
      .required("Notes are required")
      .min(1, "Notes must be at least 1 characters long")
      .max(1000, "Notes must be at most 1000 characters long"),
  });
export const OnlyPasswordSchema = yup.object({
  password: yup
    .string()
    .required("Please provide a valid password")
    .min(8, "Password should be more than 8 characters"),
});
export const SharedPasswordSchema = yup.object({
  shareWith: yup.string().required("Please select a user to share with"),
});

export const SharedPasswordSchema2 = yup.object().shape({
  selectedUsers: yup
    .array()
    .min(1, "Please select at least one user")
    .of(
      yup.object().shape({
        _id: yup.string(),
        permission: yup.string().required("Please select a permission role"),
      })
    ),
});
